export const RECOMMENDED_DESTINATIONS_MIN_LIMIT = 5;
export const LINGUA_TITLE_KEY = {carousel_title: 'carousel.popularPlaceTitle'};
export const SERP_LARGE_SEARCH_TERM_DESTINATION =
    'SERP_LARGE_SEARCH_TERM_DESTINATION';
export const BREAKPOINTS = {
    '1200': 6.23,
    '992': 6.23,
    '768': 6.23,
    '480': 4,
    '0': 4
};
export const SERP_DISCOVER_MORE_DESTINATION = 'SERP_DISCOVER_MORE_DESTINATION';
export const LINGUA_TITLE_KEY_BOTTOM_CAROUSEL = {
    carousel_title_large_result:
        'destinationCarouselTitleBottomOfSERP.largeResult',
    carousel_title_small_result:
        'destinationCarouselTitleBottomOfSERP.smallResult'
};
